import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { useT } from "@/i18n";

const IMG = "/images/monferrato.webp";

export const Monferrato = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const t = useT().monferrato;

  return (
    <section id="monferrato" ref={ref} className="overflow-hidden" data-testid="monferrato-section">
      <div className="mx-auto grid max-w-[1440px] grid-cols-12 gap-x-8 gap-y-16 px-6 py-28 lg:px-12 lg:py-44">
        <div className="col-span-12 lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="frame"
          >
            <div className="overflow-hidden">
              <motion.img
                style={{ y, scale: 1.15 }}
                src={IMG}
                alt={t.imgAlt}
                loading="lazy"
                className="aspect-[4/5] w-full object-cover lg:aspect-[5/6]"
                data-testid="monferrato-image"
              />
            </div>
          </motion.div>
        </div>

        <div className="col-span-12 flex flex-col justify-center lg:col-span-4 lg:col-start-9">
          <Reveal>
            <p className="mb-4 text-[11px] uppercase tracking-[0.35em] text-terra" data-testid="monferrato-kicker">{t.kicker}</p>
            <h2 className="font-serif text-4xl tracking-tight sm:text-5xl" data-testid="monferrato-heading">
              {t.headingA} <em className="italic text-terra">{t.headingEm}</em>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base leading-relaxed text-smoke" data-testid="monferrato-text">
              {t.p1}
            </p>
            <p className="mt-6 text-base leading-relaxed text-smoke">
              {t.p2}
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-12 space-y-6 border-t border-ink/15 pt-10">
              {t.stats.map((s) => (
                <div key={s.value} className="flex items-baseline gap-6" data-testid={`monferrato-stat-${s.value}`}>
                  <span className="w-36 shrink-0 font-serif text-3xl italic text-terra">{s.value}</span>
                  <span className="text-sm text-smoke">{s.label}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
